import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import "./ReuseableComponent.css";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const GCAutocompleteCheckbox2 = ({ options, label, placeholder, onChange }) => {
  return (
    <Autocomplete
      className="GCAutocompleteCheckbox"
      multiple
      options={options}
      disableCloseOnSelect
      getOptionLabel={(option) => option.Name1}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.Name1}
        </li>
      )}
      style={{
        width: 500,
        maxHeight: 100, // Adjust the maximum height as needed
        overflow: "auto",
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label=""
          placeholder=""
          sx={{
            "& input": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        />
      )}
      onChange={(event, value) => onChange(value)}
      PaperProps={{
        style: {
          maxHeight: 200, // Adjust the maximum height as needed
          overflow: "auto",
        },
      }}
    />
  );
};

const fTextFieldDummy = () => {};

const GCAutocompleteCheckbox1 = ({
  options = [],
  onChange = fTextFieldDummy,
  xDisabled = false,
}) => {
  return (
    <Autocomplete
      className="GCAutocompleteCheckbox"
      multiple
      options={options}
      disableCloseOnSelect
      getOptionLabel={(option) => option.Name1}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.Name1}+{"gjgjh"}
        </li>
      )}
      style={{
        width: "100%",
        maxHeight: 100, // Adjust the maximum height as needed
        overflow: "auto",
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label=""
          placeholder=""
          sx={{
            "& input": {
              paddingleft: "0px",
              paddingRight: "0px",
            },
          }}
        />
      )}
      onChange={(event, value) => onChange(value)}
      paperprops={{
        style: {
          maxHeight: 200, // Adjust the maximum height as needed
          overflow: "auto",
        },
      }}
      disabled={xDisabled}
    />
  );
};

const GCAutocompleteCheckbox = ({
  options = [],
  xDisabled = false,
  xValue = [],
  setValue,
  xtabIndex = "",
}) => {
  return (
    <div
      className="GCAutocompleteCheckbox"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        multiple
        options={options}
        disableCloseOnSelect
        getOptionLabel={(option) => option?.Name1}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option?.Cd}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option?.Name1}
          </li>
        )}
        style={{
          width: "100%",
          maxHeight: 100, // Adjust the maximum height as needed
          overflow: "auto",
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label=""
            placeholder=""
            sx={{
              "& input": {
                paddingleft: "0px",
                paddingRight: "0px",
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          if (!!setValue) {
            setValue(newValue);
          }
        }}
        value={!!xValue ? xValue : []}
        paperprops={{
          style: {
            maxHeight: 200, // Adjust the maximum height as needed
            overflow: "auto",
          },
        }}
        disabled={xDisabled}
      />
      {/* <button onClick={handleReset}>RefreshIcon</button> */}
    </div>
  );
};
export default GCAutocompleteCheckbox;
